import type * as React from 'react';

import { styled } from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import { doordash } from '@creditornot/alchemy-react/icons';
import { IconButton } from '@creditornot/cb-button';
import { Cross, Menu } from '@creditornot/cb-icons';
import { typographyCss, WoltLogo } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';

import { media } from 'common/media';

import useCurrentCompany from './hooks/useCurrentCompany';

type Props = {
  className?: string;
  onMenuIconClick?: () => void;
  icon: 'cross' | 'menu';
};

const Root = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: 48px;

  svg {
    fill: ${color.fixedWhite} !important;
  }
`;

const LogoContainer = styled.div`
  ${typographyCss.headline}
  color: ${color.fixedWhite};
  display: flex;
  gap: 16px;
  align-items: baseline;

  .title {
    opacity: 0.6;
  }
`;

const StyledWoltLogo = styled(WoltLogo)`
  fill: ${color.fixedWhite};
  width: 64px;
  height: 24px;

  @media ${media.md} {
    flex: initial;
  }
`;

const StyledDoordashLogo = styled(Icon)`
  width: 32px;
  height: 32px;
`;

const Header: React.FC<Props> = ({ className, icon, onMenuIconClick }) => {
  const { currentCompany } = useCurrentCompany();
  const { isCurrentCompanyPartnershipLCSP, isCurrentCompanyPartnershipAvailable } =
    currentCompany.data ?? {};
  return (
    <Root className={className}>
      <LogoContainer className="logo">
        {isCurrentCompanyPartnershipLCSP && (
          <StyledDoordashLogo source={doordash} size="medium" aria-label="Doordash logo" />
        )}
        {isCurrentCompanyPartnershipAvailable && !isCurrentCompanyPartnershipLCSP && (
          <StyledWoltLogo aria-label="Wolt logo" />
        )}
        <span className="title">Delivery OS</span>
      </LogoContainer>
      <IconButton
        background="transparent"
        variant="inverse"
        size="small"
        onClick={() => onMenuIconClick?.()}
      >
        {icon === 'cross' ? <Cross color={color.fixedWhite} /> : <Menu color={color.fixedWhite} />}
      </IconButton>
    </Root>
  );
};

export default Header;
